import { render } from "./ReminderConfiguration.vue?vue&type=template&id=10bdbf82&scoped=true"
import script from "./ReminderConfiguration.vue?vue&type=script&lang=js"
export * from "./ReminderConfiguration.vue?vue&type=script&lang=js"

import "./ReminderConfiguration.vue?vue&type=style&index=0&id=10bdbf82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bdbf82"]])

export default __exports__